<template>
  <div class="row justify-content-start mr-0 align-items-center">
    <div class="label col my-1 d-flex align-items-center">
      <p class="empty-category-info">
        {{
          $t('settings.card-settings-options.content-parameters.empty-category')
        }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'empty-category',
};
</script>

<style lang="scss" scoped></style>
